import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import separatorLine from "../../images/separatorLine.svg"
import APointIco from "../../images/APointIco.svg"
import BPointIco from "../../images/BPointIco.svg"

import searchIco from "../../images/search.png"

import * as gruzovikiApi from "../../utils/api.js"
// import { citiesIds } from "../../utils/services.js";
import {getCityId} from "../../utils/api.js"


function FilterPopup_old() {

    const navigate = useNavigate();

    const token = localStorage.getItem("token")
    const tg = window.Telegram?.WebApp;
    tg.expand()

    const [userId, setUserId] = useState(null);
    const [userCity, setUserCity] = useState("");

    useEffect(() => {

        let user_id
        let fromUrl = false;

        // Если доступен tg.initDataUnsafe
        if (tg?.initDataUnsafe?.user) {
            user_id = tg.initDataUnsafe.user.id;
        } else {
            // Если нужно извлечь из URL
            const params = new URLSearchParams(window.location.search);
            const idFromUrl = Number(params.get('userId'));
            user_id = idFromUrl
             if (Number.isFinite(idFromUrl) && idFromUrl > 0) {
                user_id = idFromUrl;
                fromUrl = true;
             }

        }
        
        setUserId(user_id);

        if (fromUrl) {
            navigate(`/filterNew?userId=${user_id}`, { replace: true });
        } else {
            navigate("/filterNew", { replace: true });
        }

        gruzovikiApi.getUserType(user_id, token)
            .then((userType) => {
                // if (userType === 0) {
                    // console.error("Доступ запрещен.");
                    // Закрытие приложения
                    // tg.close();
                    // alert(1)
                // } else if (userType === 2) {
                const excludedUserIds = [837143843, 5267329136, 425169377];
                if (user_id && userType === 2 && !excludedUserIds.includes(user_id)) {
                    console.log(user_id)
                    // Переадресация
                    // window.location.href = 'https://cargo.gruz.app';
                }
                // Если userType = 1, ничего не делаем и продолжаем выполнение
            })
            .catch((err) => {
                console.error("Ошибка получения типа пользователя:", err);
            });
    }, []);

    console.log(userId)

    let todayDate = new Date()
    let tomorrowDate = new Date()
    tomorrowDate.setDate(todayDate.getDate() + 1)
    let afterTomorrowDate = new Date()
    afterTomorrowDate.setDate(todayDate.getDate() + 2)
    // let yesterdayDate = new Date()
    // yesterdayDate.setDate(todayDate.getDate() - 1)

    const opened = true
    const [filtersArray, setFiltersArray] = useState({
        cities: [],
        dates: [todayDate, tomorrowDate],
        dateChoose: 'tomorrow',
        radiusA: 0,
        radiusB: 0,
        anywhereA: false,
        anywhereB: false,
        useMyCityA: false,
        useMyCityB: false,
        findReturn: false
    })

    
      const [citiesArray, setCitiesArray] = useState([
        {
            cityId: 1,
            name: '',
            error: false
        },
        {
            cityId: 2,
            name: '',
            error: false
        }
    ])
    const [filteredCities, setFilteredCities] = useState([]); // Фильтрованные города
    const [showDropdown, setShowDropdown] = useState(0); // Показывать ли выпадающий список



    useEffect(() => {
        gruzovikiApi.getUserFilters(userId, token)
            .then((data) => {
                if (data) {
                    let fromDate
                    let toDate
                    switch (data.dateChoose) {
                        case ('today'):
                            fromDate = todayDate
                            toDate = todayDate
                            break;
                        case ('tomorrow'):
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break;
                        case ('next'):
                            fromDate = todayDate
                            toDate = afterTomorrowDate
                            break;
                        case ('from-today'):
                            fromDate = todayDate
                            toDate = null
                            break;
                        case ('from-tomorrow'):
                            fromDate = tomorrowDate
                            toDate = null
                            break;
                        default: // Этот блок выполняется, если ни одно условие не совпало
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break;
                    }

                    // Если данные есть, устанавливаем их в filtersArray
                    setCitiesArray((prev) => [
                        { cityId: 1, name: data.from_city || '', error: false },
                        { cityId: 2, name: data.to_city || '', error: false }
                    ]);
                    setFiltersArray((prev) => ({
                        ...prev,
                        radiusA: data.radius_from_city || 0,
                        radiusB: data.radius_to_city || 0,
                        anywhereA: data.anywhereA || false,
                        anywhereB: data.anywhereB || false,
                        useMyCityA: data.useMyCityA || false,
                        useMyCityB: data.useMyCityB || false,
                        findReturn: data.findReturn || false,
                        dates: [fromDate, toDate],
                        dateChoose: data.dateChoose || 'tomorrow'
                    }));
                }
            })
            .catch((err) => {
                console.error("Ошибка получения фильтров:", err);
            });

        gruzovikiApi.getUserCity(userId, token)
        .then((data) => {
            if (data) {
                setUserCity(data);
            }
        })
        .catch((err) => {
            console.error("Ошибка получения фильтров:", err);
        });


    }, [userId]);

    const handleInputChange = (e) => {
        const { name, value, type, checked, id } = e.target;
        if (type === "checkbox") {
            setFiltersArray((prevInputs) => {
                // const updatedVehicleType = checked
                    // ? [...prevInputs.vehicleType, value]
                    // : prevInputs.vehicleType.filter((type) => type !== value);
                // return { ...prevInputs, vehicleType: updatedVehicleType };
                return { ...prevInputs};
            });
        } else {
            setFiltersArray((prevInputs) => {
                let updatedValue;
                switch (type) {
                    case 'number':
                        updatedValue = value ? Number(value) : 0;
                        break;
                    case 'date':
                        updatedValue = value ? new Date(value) : 0;
                        break;
                    default:
                        updatedValue = value || 0;
                        break;
                }

                if (id === "from") {
                    // Устанавливаем значение в нулевой индекс массива
                    return {
                        ...prevInputs,
                        [name]: [updatedValue, ...(prevInputs[name].slice(1) || [0, 0])]
                    };
                } else if (id === "to") {
                    // Устанавливаем значение в первый индекс массива
                    return {
                        ...prevInputs,
                        [name]: [(prevInputs[name][0] !== undefined ? prevInputs[name][0] : 0), updatedValue, ...(prevInputs[name].slice(2) || [0, 0])]
                    };
                } else {
                    // Для других случаев
                    return { ...prevInputs, [name]: updatedValue };
                }
            });
        }
    };

    const handleReset = () => {
        setCitiesArray([{
            cityId: 1,
            name: ''
        },
        {
            cityId: 2,
            name: ''
        }
        ])
        setFiltersArray({
            cities: [],
            dates: [todayDate, tomorrowDate],
            dateChoose: 'tomorrow',
            radiusA: 0,
            radiusB: 0
        })
    };

    console.log(citiesArray)

    const handleSubmit = async () => {
        const results = await Promise.all(
            citiesArray.map(async (city, index) => {
      
              // Если anywhereA или anywhereB — пропускаем проверку 
              if ((index === 0 && filtersArray.anywhereA) || (index === 1 && filtersArray.anywhereB)) {
                return true; // любое число > 0, чтобы считался валидным
              }
              
              const trimmedName = city.name.trim();

              // Для реального города вызываем getCityId
              const cityId = await getCityId(trimmedName);
              return { trimmedName, cityId };
            })
          );
      
          // 2. Проверяем корректность всех городов:
          const isValid = results.every(({ trimmedName, cityId }) => {
            // Валидно, если trimmedName не пустой и cityId не 0
            console.log(cityId)
            return trimmedName !== '' && cityId !== 0;
          });

        // 3. Формируем updatedCitiesArray, используя уже полученные результаты
        const updatedCitiesArray = results.map(({ trimmedName, cityId }, index) => ({
            ...citiesArray[index],
            name: trimmedName,
            error: trimmedName === '' || cityId === 0,
        }));
        
        // 4. Обновляем стейт
        setCitiesArray(updatedCitiesArray);
    
    
        if (!isValid) {
            console.log('no')
            return; // Если данные некорректны, прекращаем выполнение
        }
    
        // Формируем массив городов для отправки
        const submitCitiesArray = updatedCitiesArray
            
            .map(city => city.name);
    
        // Обновляем filtersArray
        setFiltersArray((prevInputs) => ({
            ...prevInputs,
            cities: submitCitiesArray,
        }));
    
        // Отправляем запрос
        gruzovikiApi
            .searchOrders({ ...filtersArray, cities: submitCitiesArray }, userId)
            .then(res => {
                console.log(res);
            })
            .catch(err => {
                console.error(err);
            });

        // Задержка перед закрытием tg
        setTimeout(() => {
            tg.close();
        }, 500); // Задержка в 500 миллисекунд

        
    }

    const handleDateCheckboxClick = (e) => {
        const { id } = e.target
        let fromDate
        let toDate
        switch (id) {
            case ('today'):
                fromDate = todayDate
                toDate = todayDate
                break;
            case ('tomorrow'):
                fromDate = todayDate
                toDate = tomorrowDate
                break;
            case ('next'):
                fromDate = todayDate
                toDate = afterTomorrowDate
                break;
            case ('from-today'):
                fromDate = todayDate
                toDate = null
                break;
            case ('from-tomorrow'):
                fromDate = tomorrowDate
                toDate = null
                break;

        }
        setFiltersArray((prevInputs) => ({ ...prevInputs, dates: [fromDate, toDate], dateChoose: id }));
    }

    const handleCityNameChange = (e, cityId) => {
        const newName = e.target.value;

        let anywherename
        let useMyCityName

        if (cityId === 1 ) {
            anywherename = 'anywhereA'
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            anywherename = 'anywhereB'
            useMyCityName = 'useMyCityB'
        }


        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        );
        setCitiesArray(updatedCitiesArray);

        // Фильтрация городов
        if (newName.trim() === '') {
            setFilteredCities([]);
            setShowDropdown(0);
        } else {
            // const filtered = Object.keys(citiesIds).filter((city) =>
            //     city.toLowerCase().startsWith(newName.toLowerCase()) // Проверяем только начало строки
            // );
            // setFilteredCities(filtered);
            // setShowDropdown(cityId);
            
            gruzovikiApi.filterCities(newName)
                .then((data) => {
                    setFilteredCities(data);
                    setShowDropdown(cityId);
                })
                .catch((err) => {
                    console.error('Ошибка при фильтрации городов:', err);
                });

        }

        let submitCitiesArray = updatedCitiesArray.filter(city => city.name !== '').map(city => city.name)
        setFiltersArray((prevInputs) => {
            return { ...prevInputs, cities: submitCitiesArray, [anywherename]: false, [useMyCityName]: false};
        });
    };

    
    const handleCitySelect = (newCity, cityId) => {
        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newCity } : city
        );
        setCitiesArray(updatedCitiesArray);

        // Закрываем выпадающий список
        setShowDropdown(0);
        setFilteredCities([]);
    };


    // Обработчик изменения состояния чекбокса Мой город
    const handleCheckboxMyCityChange = (e, cityId) => {
        let newName
        let anywherename
        let useMyCityName
        if (e.target.checked) {
            newName = userCity;
        } else {
            newName = "";
        }

        if (cityId === 1 && e.target.checked === true) {
            anywherename = 'anywhereA'
        } else if (cityId === 2 && e.target.checked === true) {
            anywherename = 'anywhereB'
        }

        if (cityId === 1 ) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName, error: false } : city
        );
        setCitiesArray(updatedCitiesArray);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [anywherename]: false, [useMyCityName]: e.target.checked};
        });
    };

    // Обработчик изменения состояния откуда-куда угодно
    const handleCheckboxAnywhereChange = (e) => {
        const { name, checked } = e.target;

        let checkCityId
        let useMyCityName
        if (name === 'anywhereA') {
            checkCityId = 1
        } else {
            checkCityId = 2
        }

        if (checkCityId === 1 && e.target.checked === true) {
            useMyCityName = 'useMyCityA'
        } else if (checkCityId === 2 && e.target.checked === true) {
            useMyCityName = 'useMyCityB'
        }

        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === checkCityId ? { ...city, name: '', error: false} : city
        );
        setCitiesArray(updatedCitiesArray);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [name]: e.target.checked, [useMyCityName]: false};
        });

        console.log(name, checked)

    };

    // Обработчик поиска обратки
    const handleCheckboxFindReturnChange = (e) => {
        const { name, checked } = e.target;

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [name]: e.target.checked};
        });

        console.log(name, checked)

    };

    const handleClearCityName = (e, cityId) => {
        const newName = '';

        let useMyCityName

        if (cityId === 1 ) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2 ) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        );
        setCitiesArray(updatedCitiesArray);

        setShowDropdown(0);
        setFilteredCities([]);

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [useMyCityName]: false};
        });

    };

    console.log(filtersArray)

    return (
        <div className={opened ? "filter-container" : "filter-container filter-container_closed"}>

            <div className="filter-popup__grabber" />
            {
                opened ?
                    <div className="filter-popup_categories">
                        {/* <img src={truckIco} alt="" className="filter-popup__start-img-1" /> */}
                        <img src={searchIco} alt="" className="filter-popup__start-img" />

                        <div className="filter-popup__cities filter-popup__category-container">
                            {/* <div className="filter-popup__show-filter-button filter-popup__category-button">
                                Направление
                            </div> */}

                            <div className="filter-popup__container">
                                <div className="filter-popup__top-row">
                                    <div className="filter-popup__from-block">
                                        <img src={APointIco} alt="A" className="filter-popup__icon" />
                                        <span className="filter-popup__label">Откуда</span>
                                    </div>
                                    
                                    <div className="filter-popup__toggle-block">
                                        <span className="filter-popup__toggle-label">Мой город</span>
                                        <label className="filter-popup__slider-container">
                                            <input type="checkbox" className="filter-popup__checkbox" checked={filtersArray.useMyCityA} disabled={userCity ? false : true} onChange={(e) => handleCheckboxMyCityChange(e, 1)}/>
                                            <span className="filter-popup__slider"></span>
                                        </label>
                                    </div>
                                    
                                    <div className="filter-popup__radius-block">
                                        <span className="filter-popup__label">Радиус</span>
                                    </div>
                                </div>
                            
                                <div className="filter-popup__bottom-row">
                                    <div className="filter-popup__input-wrapper">
                                        <input
                                            type="text"
                                            placeholder={`${filtersArray.anywhereA ? 'Откуда угодно' : 'Например Томск'}`}
                                            className={`filter-popup__input ${citiesArray[0].error ? 'input-error' : ''}`}
                                            name="startCity" id="adress-a"
                                            value={citiesArray[0].name}
                                            onChange={(e) => handleCityNameChange(e, 1)}
                                            onFocus={() => setShowDropdown(1)} // Показываем список при фокусе
                                            onBlur={() => setTimeout(() => setShowDropdown(0), 100)} // Скрываем список с задержкой
                                        />

                                        {citiesArray[0].name && (
                                            <button
                                                type="button"
                                                className="filter-popup__clear-button"
                                                onClick={(e) => handleClearCityName(e, 1)}
                                            >
                                                ×
                                            </button>
                                        )}

                                        {showDropdown === 1 && filteredCities.length > 0 && (
                                            <ul className="filter-popup__dropdown">
                                                {filteredCities.map((city) => (
                                                    <li
                                                        key={city}
                                                        className="filter-popup__dropdown-item"
                                                        onClick={() => handleCitySelect(city, 1)}
                                                    >
                                                        {city}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>
                                    
                                    <input placeholder="км" type='number' maxLength="3" name='radiusA' id='radius-a' className='filter-popup__radius-input'  value={filtersArray.radiusA === 0 ? '' : filtersArray.radiusA} onChange={handleInputChange}
                                            min={0}
                                            onKeyDown={(event) => {
                                                if (event.code === 'Minus') {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                </div>

                                <div className="filter-popup__toggle-block toggle-anywhere">
                                    <span className="filter-popup__toggle-label">Откуда угодно</span>
                                    <label className="filter-popup__slider-container">
                                        <input name="anywhereA" type="checkbox" className="filter-popup__checkbox" checked={filtersArray.anywhereA} onChange={(e) => handleCheckboxAnywhereChange(e)}/>
                                        <span className="filter-popup__slider"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="filter-popup__container">
                                <div className="filter-popup__top-row">
                                    <div className="filter-popup__from-block">
                                        <img src={BPointIco} alt="B" className="filter-popup__icon" />
                                        <span className="filter-popup__label">Куда</span>
                                    </div>
                                    
                                    <div className="filter-popup__toggle-block">
                                        <span className="filter-popup__toggle-label">Мой город</span>
                                        <label className="filter-popup__slider-container">
                                            <input type="checkbox" className="filter-popup__checkbox" checked={filtersArray.useMyCityB} disabled={userCity ? false : true}  onChange={(e) => handleCheckboxMyCityChange(e, 2)}/>
                                            <span className="filter-popup__slider"></span>
                                        </label>
                                    </div>
                                    
                                    <div className="filter-popup__radius-block">
                                        <span className="filter-popup__label">Радиус</span>
                                    </div>
                                </div>
                            
                                <div className="filter-popup__bottom-row">
                                    <div className="filter-popup__input-wrapper">
                                        <input
                                            type="text"
                                            placeholder={`${filtersArray.anywhereB ? 'Куда угодно' : 'Например Новосибирск'}`}
                                            className={`filter-popup__input ${citiesArray[1].error ? 'input-error' : ''}`}
                                            name="endCity" id="adress-b"
                                            value={citiesArray[1].name}
                                            onChange={(e) => handleCityNameChange(e, 2)}
                                            onFocus={() => setShowDropdown(2)} // Показываем список при фокусе
                                            onBlur={() => setTimeout(() => setShowDropdown(0), 100)} // Скрываем список с задержкой 
                                        />

                                        {citiesArray[1].name && (
                                            <button
                                                type="button"
                                                className="filter-popup__clear-button"
                                                onClick={(e) => handleClearCityName(e, 2)}
                                            >
                                                ×
                                            </button>
                                        )}

                                        
                                        {showDropdown === 2 && filteredCities.length > 0 && (
                                            <ul className="filter-popup__dropdown">
                                                {filteredCities.map((city) => (
                                                    <li
                                                        key={city}
                                                        className="filter-popup__dropdown-item"
                                                        onClick={() => handleCitySelect(city, 2)}
                                                    >
                                                        {city}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}


                                    </div>
                                    
                                    <input placeholder="км" type='number' maxLength="3" name='radiusB' id='radius-b' className='filter-popup__radius-input'  value={filtersArray.radiusB === 0 ? '' : filtersArray.radiusB} onChange={handleInputChange}
                                            min={0}
                                            onKeyDown={(event) => {
                                                if (event.code === 'Minus') {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                </div>

                                <div className="filter-popup__toggle-block toggle-anywhere">
                                    <span className="filter-popup__toggle-label">Куда угодно</span>
                                    <label className="filter-popup__slider-container">
                                        <input  name="anywhereB" type="checkbox" className="filter-popup__checkbox" checked={filtersArray.anywhereB} onChange={(e) => handleCheckboxAnywhereChange(e)}/>
                                        <span className="filter-popup__slider"></span>
                                    </label>
                                </div>

                                
                            </div>

                            <div className="filter-popup__toggle-block toggle-findReturn">
                                <span className="filter-popup__toggle-label-findReturn">Искать обратку</span>
                                <label className="filter-popup__slider-container">
                                    <input  name="findReturn" type="checkbox" className="filter-popup__checkbox" checked={filtersArray.findReturn} onChange={(e) => handleCheckboxFindReturnChange(e)}/>
                                    <span className="filter-popup__slider"></span>
                                </label>
                            </div>

                            {/* <div className="filter-popup__button-containter filter-popup__category-input filter-popup__button-containter_opened">
                                <div className="filter-popup__city-input-container">
                                    
                                    <div className="filter-popup__adress-input-container filter-popup__adress-input-a">
                                        <label htmlFor="Откуда">
                                            <img src={APointIco} alt="A" className="filter-popup__a-point-icon filter-popup__input-point-icon" />
                                            Откуда
                                        </label>
                                        <input placeholder='Например Томск' type="text" name="startCity" id="adress-a" className={`filter-popup__adress-input ${citiesArray[0].error ? 'input-error' : ''}`} value={citiesArray[0].name} onChange={(e) => handleCityNameChange(e, 1)} />
                                    </div>

                                    <div className='filter-popup__radius-input-container'>
                                        <label htmlFor="Радиус">Радиус</label>
                                        <input placeholder="км" type='number' maxLength="3" name='radiusA' id='radius-a' className='filter-popup__radius-input'  value={filtersArray.radiusA === 0 ? '' : filtersArray.radiusA} onChange={handleInputChange}
                                            min={0}
                                            onKeyDown={(event) => {
                                                if (event.code === 'Minus') {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    

                                    <div className="filter-popup__adress-input-container filter-popup__adress-input-b">
                                        <label htmlFor="Откуда">
                                            <img src={BPointIco} alt="B" className="filter-popup__b-point-icon filter-popup__input-point-icon" />
                                            Куда
                                        </label>
                                        <input placeholder='Например Новосибирск' type="text" name="endCity" id="adress-b" className={`filter-popup__adress-input ${citiesArray[1].error ? 'input-error' : ''}`} value={citiesArray[1].name} onChange={(e) => handleCityNameChange(e, 2)} />
                                    </div>
                                    
                                    <div className='filter-popup__radius-input-container'>
                                        <label htmlFor="Радиус">Радиус</label>
                                        <input placeholder="км" type='number' maxLength="3" name='radiusB' id='radius-b' className='filter-popup__radius-input' value={filtersArray.radiusB === 0 ? '' : filtersArray.radiusB} onChange={handleInputChange}
                                            min={0}
                                            onKeyDown={(event) => {
                                                if (event.code === 'Minus') {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>

                                </div>
                            </div> */}

                        </div>

                        <div className="filter-popup__date filter-popup__category-container">
                            {/* <div className="filter-popup__show-filter-button filter-popup__category-button"> */}
                                    {/*  */}
                            {/* </div> */}
                            <div className="filter-popup__date-input-containter filter-popup__category-input filter-popup__date-input-containter_opened">
                                {/* Дата */}
                                <div className="filter-popup__date-inputs">
                                    <input type="date" className="filter-popup__date-input filter-popup__num-input" value={filtersArray.dates[0] ? new Date(filtersArray.dates[0]).toISOString().split('T')[0] : ''} name="dates" id="from" onChange={handleInputChange} />
                                    <img src={separatorLine} alt="--" className="filter-popup__separator" />
                                    <input type="date" className="filter-popup__date-input filter-popup__num-input" value={filtersArray.dates[1] ? new Date(filtersArray.dates[1]).toISOString().split('T')[0] : ''} name="dates" id="to" onChange={handleInputChange} />
                                </div>
                                <div className="filter-popup__date-checkbox-container">
                                    <div className="filter-popup__row">
                                        <div className="filter-popup__check-button-container filter-popup_check-today">
                                            <input type="radio" name="date" id="today" value={todayDate} className="filter-popup__check-button" onChange={handleDateCheckboxClick} checked={filtersArray.dateChoose === 'today' ? true : false} />
                                            <label htmlFor="today" className="filter-popup__check-button-label">СЕГОДНЯ</label>
                                        </div>
                                        <div className="filter-popup__check-button-container filter-popup_check-tomorrow">
                                            <input type="radio" name="date" id="tomorrow" value={tomorrowDate} className="filter-popup__check-button" onChange={handleDateCheckboxClick} checked={filtersArray.dateChoose === 'tomorrow' ? true : false} />
                                            <label htmlFor="tomorrow" className="filter-popup__check-button-label">СЕГОДНЯ - ЗАВТРА</label>
                                        </div>
                                    </div>
                                    <div className="filter-popup__row">
                                        <div className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="next" value={afterTomorrowDate} className="filter-popup__check-button" onChange={handleDateCheckboxClick} checked={filtersArray.dateChoose === 'next' ? true : false} />
                                            <label htmlFor="next" className="filter-popup__check-button-label">СЕГОДНЯ - ЗАВТРА - ПОСЛЕЗАВТРА</label>
                                        </div>
                                    </div>
                                    <div className="filter-popup__row">
                                        <div className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="from-today" value={afterTomorrowDate} className="filter-popup__check-button" onChange={handleDateCheckboxClick} checked={filtersArray.dateChoose === 'from-today' ? true : false} />
                                            <label htmlFor="from-today" className="filter-popup__check-button-label">С СЕГОДНЯШНЕГО</label>
                                        </div>
                                        <div className="filter-popup__check-button-container filter-popup_check-next-day">
                                            <input type="radio" name="date" id="from-tomorrow" value={afterTomorrowDate} className="filter-popup__check-button" onChange={handleDateCheckboxClick} checked={filtersArray.dateChoose === 'from-tomorrow' ? true : false} />
                                            <label htmlFor="from-tomorrow" className="filter-popup__check-button-label">С ЗАВТРАШНЕГО</label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="filter-popup__submit-button-container">
                            <button className="filter-popup__submit-button" onClick={() => handleSubmit()}>ИСКАТЬ ГРУЗ</button>
                            <button className="filter-popup__reset-button" onClick={() => handleReset()}>Сбросить поиск</button>
                        </div>
                        
                    </div>
                    :
                    <></>
            }
        </div>
    )
}

export default FilterPopup_old;